function swellLoaded(callback) {
  if (swellReady()) {
    callback();
  } else {
    let maxRetries = 10;
    let retryCount = 1;
    let retrySwellAPI = setInterval(() => {
      // console.log("Checking on swell...")
      if (swellReady() || retryCount >= maxRetries) {
        clearInterval(retrySwellAPI);
        callback();
      }
      retryCount++;
    }, 500);
  }
}

function swellReady() {
  if ('swellAPI' in window) {
    try {
      let customerInfo = window.swellAPI.getCustomerDetails();

      if (!customerInfo?.email && !window.shopifyCustomer) {
        return true;
      } else {
        if (customerInfo?.isMember !== undefined) {
          return true;
        }
      }
    } catch(e) {}
  }
  return false;
}

class Rewards {
  constructor() {
    this.swellInit = false;
    this.init();
  }

  init() {
    document
      .querySelectorAll("[data-swell-hide],[data-swell-if-field]")
      .forEach((element) => {
        element.classList.add("swell-loading");
      });

    // Recommended document.addEventListener("swell:setup"() => {}) is not reliable
    // because other third parties like CrazyRocket load jQuery which causes Yotpo
    // to fire jQuery events instead
    const boundCallback = this.populateSwellRewards.bind(this);
    swellLoaded(boundCallback);
  }

  populateSwellRewards() {
    if (!('swellAPI' in window) || this.swellInit) {
      return false;
    }

    this.swellInit = true;
    const self = this;

    let customerInfo = window.swellAPI.getCustomerDetails();
    let swellTiers = window.swellAPI.getVipTiers().sort((a, b) => a.rank - b.rank);

    if (customerInfo.optedInAt) {
      let optedInAt = moment(customerInfo.optedInAt);
      customerInfo.optedInAtDateString = optedInAt.format('MMM D, YYYY');
    }

    if (customerInfo.vipTier && customerInfo.vipTier.vipTierSubscriptionDate) {
			// Set the date that the points expire. 1 Year from the date the current tier was reached
			let expirationDate = moment(customerInfo.vipTier.vipTierSubscriptionDate)
			customerInfo.vipTier.subscriptionDateString = expirationDate.format('MMM D, YYYY')
			expirationDate.add(1, 'years').subtract(1, 'days')
			customerInfo.vipTier.byDateString = expirationDate.format('MMM D, YYYY')
		}

    try {
      // Figure out the next tier
      let nextTier = null;

      if (customerInfo.vipTierStats) {
        nextTier = swellTiers.find(tier => {
          return tier.swellrequiredPointsEarned > customerInfo.vipTierStats.pointsEarned;
        });
      }

      if (nextTier) {
        customerInfo.nextTier = nextTier;
        let requiredPoints = nextTier.swellrequiredPointsEarned - customerInfo.vipTierStats.pointsEarned;

        customerInfo.nextTier.spend = window.Shopify.formatMoney(
          requiredPoints * 100,
          window.theme.moneyFormat
        );
        customerInfo.nextTier.earn = requiredPoints;
      }
    } catch (error) {
      console.log('No next VIP Tier Stats', error);
    }

    let currentTierIndex = false;
    let nextTierIndex = false;

    try {
      let vipTierId = customerInfo.vipTier ? customerInfo.vipTier.id : null;

      switch (vipTierId) {
        case swellTiers[0].id:
          currentTierIndex = 1;
          nextTierIndex = 2;
          document.querySelectorAll('[data-swell-unlock-carousel-tier-index="1"]').forEach(el => el.remove());
          break;
        case swellTiers[1].id:
          currentTierIndex = 2;
          nextTierIndex = 3;
          document.querySelectorAll('[data-swell-unlock-carousel-tier-index="1"], [data-swell-unlock-carousel-tier-index="2"]').forEach(el => el.remove());
          break;
        case swellTiers[2].id:
          currentTierIndex = 3;
          nextTierIndex = 4;
          document.querySelectorAll('[data-swell-unlock-carousel-tier-index="1"], [data-swell-unlock-carousel-tier-index="2"], [data-swell-unlock-carousel-tier-index="3"]').forEach(el => el.remove());
          break;
        case swellTiers[3].id:
          currentTierIndex = 4;
          nextTierIndex = false;
          document.querySelectorAll('.swell-unlock-tiers, .swell-welcome__status').forEach(el => el.remove());
          break;
        default:
          document.querySelectorAll('.swell-welcome__status').forEach(el => el.remove());
      }

      let progressData = {
        currentPoints: customerInfo.vipTierStats.pointsEarned,
        minPoints: 0,
        maxPoints: 0,
        currentTier: currentTierIndex,
        nextTier: nextTierIndex
      };

      if (currentTierIndex) {
        progressData.minPoints = swellTiers[currentTierIndex - 1].swellrequiredPointsEarned;
      }

      if (nextTierIndex) {
        progressData.maxPoints = swellTiers[nextTierIndex - 1].swellrequiredPointsEarned - 1;
      }

      this.updateProgressMeter(progressData);

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          self.updateProgressMeter(progressData);
        }, 250);
      });
    } catch (error) {
      document.querySelectorAll('.swell-welcome__status').forEach(el => el.remove());
      console.log('Unable to update tier progress.');
    }

    let replacements = this.recursiveDash(customerInfo);
    console.log('Swell Fields', replacements);
    let swellProperties = Object.keys(replacements);

    document.querySelectorAll('[data-swell-field]').forEach(element => {
      const field = element.getAttribute('data-swell-field');
      if (swellProperties.includes(field)) {
        element.innerText = replacements[field];
        element.classList.add('swell-field');
        element.classList.remove('swell-loading');
      }
    });

    document.querySelectorAll('[data-swell-if-field]').forEach(element => {
      let field = element.getAttribute('data-swell-if-field');
      let match = false;
      if (element.hasAttribute('data-swell-if-value-in')) {
        let values = JSON.parse(element.getAttribute('data-swell-if-value-in'));
        match = values.includes(replacements[field]);
      } else {
        match = replacements[field] == element.getAttribute('data-swell-if-value');
      }

      if (element.hasAttribute('data-swell-if-else')) {
        match = !match;
      }

      if (match) {
        element.classList.add('swell-field');
        element.classList.remove('swell-loading');
      } else {
        element.style.display = 'none';
        element.classList.add('swell-hidden');
        element.classList.remove('swell-loading');
      }
    });

    document.querySelectorAll('[data-swell-hide]').forEach(element => {
      if (!swellProperties.includes(element.getAttribute('data-swell-hide'))) {
        element.style.display = 'none';
        element.classList.add('swell-hidden');
        element.classList.remove('swell-loading');
      }
    });

    document.querySelectorAll('.swell-loading').forEach(element => element.classList.remove('swell-loading'));

    document.documentElement.classList.add('swell--loaded');
  }

  updateProgressMeter(data) {
    document.querySelector(`[data-tier-index="${data.currentTier}"]`)?.classList.add('swell-welcome__tier--current');
    document.querySelector(`[data-tier-index="${data.nextTier}"]`)?.classList.add('swell-welcome__tier--next');

    if (data.currentTier && data.nextTier) {
      let tierProgress = (data.currentPoints - data.minPoints) / (data.maxPoints - data.minPoints);
      let tierElement = document.querySelector(`[data-tier-index="${data.currentTier}"]`);
      let nextTierElement = document.querySelector(`[data-tier-index="${data.nextTier}"]`);
      let tierStart = tierElement.offsetLeft + tierElement.offsetWidth;
      let meterPosition = ((nextTierElement.offsetLeft - tierStart) * tierProgress) + tierStart + 10;

      document.querySelectorAll('[data-progress-width]').forEach(el => {
        el.style.width = `${parseInt(meterPosition)}px`;
      });
      document.querySelectorAll('[data-progress-left]').forEach(el => {
        el.style.left = `${parseInt(meterPosition)}px`;
      });
    } else if (data.currentTier && !data.nextTier) {
      document.querySelector('.swell-welcome__progress')?.classList.add('swell-welcome__progress--complete');
    } else {
      console.log('Unable to update tier progress.');
    }
  }

  recursiveDash(obj) {
    let newobj = {};
    let recurse = (obj, current) => {
      for (const prop in obj) {
        const key = current ? `${current}.${prop}` : prop;
        if (obj[prop] && typeof obj[prop] === "object") {
          recurse(obj[prop], key);
        } else {
          newobj[key] = obj[prop];
        }
      }
    };
    recurse(obj);
    return newobj;
  }
}

new Rewards();

class RewardTiers {
  constructor() {
    this.init();
  }

  init() {
    const boundCallback = this.buildTierLevels.bind(this);
    swellLoaded(boundCallback);
  }

  buildTierLevels() {
    let swellTiers = window.swellAPI.getVipTiers();
    let tierRanges = swellTiers.map(tier => ({
      id: tier.id,
      name: tier.name,
      lower: tier.swellrequiredPointsEarned,
      upper: '+'
    }));

    tierRanges.sort((a, b) => a.lower - b.lower);

    for (let i = 0; i < tierRanges.length - 1; i++) {
      tierRanges[i].upper = `-${tierRanges[i + 1].lower - 1}`;
    }

    tierRanges.forEach(tier => {
      let tierElement = document.querySelector(`[data-tier-id="${tier.id}"]`);
      if (tierElement) {
        let tierRange = tierElement.querySelector('.points-item');
        if (tierRange) {
          tierRange.textContent = `${tier.lower}${tier.upper}`;
        }

        let tierName = tierElement.querySelector('.name-item');
        if (tierName) {
          tierName.textContent = tier.name;
        }
      }
    });
  }
}

new RewardTiers();